module.exports = __webpack_public_path__ + "static/media/lunch4.f1e2540f.png";